import type Database from '../../database/Database';
// eslint-disable-next-line import/no-cycle
import saveGlobalTagsCountMiddleware from '../../database/internals/saveGlobalTagsCountMiddleware';
import { getAreAudiobooksEnabled } from '../../utils/env.platform';
import { isTest } from '../../utils/environment';
// eslint-disable-next-line import/no-cycle
import { populateMetadataSearchMiddleware } from './populateMetadataSearchMiddleware';
import { setupAudiobookContentLoading } from './setupAudiobookContentLoading';

export const additionalMiddleware = async (database: Database) => {
  if (!database.rxDbInstance) {
    throw new Error('database.rxDbInstance is falsy');
  }

  saveGlobalTagsCountMiddleware(database);
  if (!isTest) {
    populateMetadataSearchMiddleware(database.rxDbInstance);
    if (getAreAudiobooksEnabled()) {
      // Johannes: Even though this code does not get executed as part of Reader
      // it still gets bundled. I tried dynamically importing it but could not make this
      // work as part of the audiobooks PR. we thus need to be very careful to never
      // call the native audiobook modules as part of module initialization.
      await setupAudiobookContentLoading(database);
    }
  }
};
